import { render, staticRenderFns } from "./AddNotebookNoteDialog.vue?vue&type=template&id=0a1a63d6&"
import script from "./AddNotebookNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddNotebookNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNotebookNoteDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports